module.exports = __webpack_public_path__ + "img/background_1.6ea3e3f8.png";